export const assignfilterOptions = [
  {
    labels: "Status", 
    value: false,
  },

 {
    labels: "Date Created",
    value: false,
  },
  {
    labels: "Last Run",
    value: false,
  },
  {
    labels: "Address",
    value: false,
  }
];
export const CREATED_TIME_OPTIONS = [
  { label: "Custom", value: "Custom" },
];
export const STATUS_OPTIONS = [
  { label: "Active", value: "ACTIVE" },
  { label: "In-Active", value: "INACTIVE" },
];
